<template>
  <section class="proList">
    <div class="proList-btns">
      <a :href="linkStr" download>下载</a>
    </div>
    <div class="filterList">
      <div class="divRow">
        <div class="title">
          产品分类:
        </div>
        <el-radio-group v-model="params.commodity_type_code" size="medium" @change="init">
          <el-radio-button v-for="(item,index) in codeList" :key="index" :label="item.commodity_type_code">
            {{ item.commodity_type_name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="divRow">
        <div class="title">
          是否选配:
        </div>
        <el-radio-group v-model="params.is_must" size="medium" @change="init">
          <el-radio-button label="">
            全部
          </el-radio-button>
          <el-radio-button :label="1">
            否
          </el-radio-button>
          <el-radio-button :label="0">
            是
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div v-loading.fullscreen.lock="loading" class="proList-content">
      <div
        v-if="data1"
      >
        <!-- <com-table :data="data1" :configs="proListInfo.obj.table2">
          <template v-slot:operate="{ row }">
            <el-tooltip
              effect="light"
              placement="top"
              :content="row.description"
              transition="el-fade-in"
            >
              <span class="tex-ellipsis-clamp2">{{ row.description }}</span>
            </el-tooltip>
          </template>
        </com-table> -->
        <el-table
          :data="data1"
          style="width: 100%">
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50" />
          <el-table-column
            v-for="(item,index) in tableColumn"
            :key="index"
            align="center"
            :prop="item.model"
            :label="item.label"
            :width="item.width">
            <template slot-scope="{ row, column, $index }">
              <template v-if="item.model == 'description'">
                <el-tooltip
                  effect="light"
                  placement="top"
                  :content="row.description"
                  transition="el-fade-in"
                >
                  <span class="tex-ellipsis-clamp2">{{ row.description }}</span>
                </el-tooltip>
              </template>
              <template v-else>
                {{ row[item.model] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
// import comTable from '@/components/comTable'
export default {
  // components: { comTable },
  data() {
    return {
      radio1: '上海',
      proListInfo: mock.proList.proList.viewInfo,
      proListInit: mock.proList.proList.init,
      data1: null,
      subjects: null,
      linkStr: null,
      loading: false,
      params: {
        listing_id: null,
        is_must: '',
        commodity_type_code: ''
      },
      tableColumn: [
        {
          model: 'name',
          label: '产品名',
          width: '200'
        },
        // {
        //   type: 'text',
        //   model: 'brand_name',
        //   label: '产品品牌名',
        //   width: '100',
        //   align: 'center'
        // },
        {
          model: 'description',
          label: '产品描述'
        },
        {
          model: 'commodity_type_name',
          label: '产品分类'
        },
        {
          model: 'num',
          label: '产品数量',
          width: '100'
        },
        // {
        //   model: 'unit_price',
        //   label: '单价/元',
        //   width: '100'
        // },
        {
          model: 'unit',
          label: '产品单位',
          width: '100'
        },
        {
          model: 'is_must',
          label: '产品匹配',
          width: '100'
        }
        // {
        //   type: 'text',
        //   model: 'commodity_total_price',
        //   label: '合计/元',
        //   width: '100',
        //   align: 'center'
        // }
      ],
      codeList: []
    }
  },
  computed: {},
  created() {
    if (this.$route.query.id) {
      this.params.listing_id = this.$route.query.id
      this.linkStr = `${process.env.VUE_APP_BASE_API}api/download_listingdetail?id=${this.$route.query.id}`
    }
    this.loading = true
    this.init()
  },
  mounted() {},
  methods: {
    async init() {
      const data = await this.proListInit.dto(this.params)
      this.data1 = data.data
      this.codeList = [{
        commodity_type_code: '',
        commodity_type_name: '全部'
      }].concat(data.commodity_type_code_option)
      this.loading = false
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>

<style scoped lang="scss">
.proList {
  @include fun-layout(1);
  width: $xr-medium-width;
  &-btns {
    display: flex;
    justify-content: flex-end;
    a {
      display: block;
      width: 60px;
      line-height: 40px;
      text-align: center;
      border-radius: 6px;
      color: #fff;
      background-color: #2f82ff;
      font-size: 14px;
      font-weight: bolder;
    }
  }
  &-content {
    margin-top: 12px;
    padding: 20px;
    overflow: hidden;
    background-color: #fff;
    // height: 730px;
    button {
      color: #666;
    }
  }
}
.filterList{
  .divRow{
    display: flex;
    // align-items: center;
    margin-bottom: 20px;
    .title{
      font-size: 14px;
      display: inline-block;
      color: #000;
      font-weight: 500;
      flex-shrink: 0;
      margin-top: 17px;

    }
    .el-radio-button{
      margin:10px;
      box-shadow: 0px 3px 3px 0px rgba(85, 85, 85, 0.1);
    }
  }
}
</style>
